module.exports = "/dist/src/img/backgrounds/2023-saved.svg";